import advancedSearchMobile from '../../../modules/M15-advanced-search-mobile/M15-advanced-search-mobile.pug';
import $ from 'jquery';
var that;

export const RealEstateSearchResultComponent = {
	transclude: true,
	templateUrl: 'real-estate-search-result.html',
	controller: class RealEstateSearchResultComponent {
		constructor(SearchService, $mdDialog, $timeout, niceUrlService, $rootScope, $scope, SearchesService, WebWalkService,
			notificationService, loaderService, $filter) {
			'ngInject';
			this.SearchService = SearchService;
			this.searchesService = SearchesService;
			this.$mdDialog = $mdDialog;
			this.$timeout = $timeout;
			this.$rootScope = $rootScope;
			this.niceUrlService = niceUrlService;
			this.$scope = $scope;
			this.webWalk = WebWalkService;
			this.notificationService = notificationService;
			this.loaderService = loaderService;
			this.formData = {};
			this.$filter = $filter;
			this.niceUrl = '';
			this.searchCount = 0;
			this.searchCountWithParams = 0;
			this.$scope.$watch('$ctrl.searchCount', (newValue) => {
				if (newValue == 2) {
					this.propertySearch(this.formData);
				}
			});
			// keresők inicializálása után keresés indítása paraméterek alapján
			this.$scope.$watch('$ctrl.searchCountWithParams', (newValue) => {
				if (newValue == 2 && window.searchParams) {
					this.propertySearch();
				}
			});
			this.$scope.$on('hideAdvancedSearch', () => {
				this.showAdvancedSearch = false;
			});
			this.$scope.$on('isOwnedByFactoring', (event, data) => {
				this.isOwnedByFactoring = data.value;
			});
			this.$scope.$on('estateLiked', (e, info) => {
				this.$scope.$broadcast('estateLikedToList', info);
			});
			this.$scope.$on('hoverOnElement', (e, item) => {
				if (window.google && window.google.maps) {
					this.$scope.$broadcast('showInfoWindow', item);
				}
			});
			that = this;
		}

		$onInit() {
			this.isLoggedIn = this.$rootScope.isLoggedIn;
			this.showMap = false;
			this.showList = true;
			this.firstLoad = { searchBar: true, advanced: true };
			this.fixSearchBarToTop();
			if (angular.element('.ALIST-app').length) {
				this.$scope.$on('advancedSearchInitialized', () => {
					this.searchCount++;
				});
				this.$scope.$on('propertySearchBarInit', () => {
					this.searchCount++;
				});
			}
			// APLIS
			if (angular.element('.APLIS-app').length) {
				this.$scope.$on('advancedSearchInitialized', () => {
					this.searchCountWithParams++;
				});
				this.$scope.$on('propertySearchBarInit', () => {
					this.searchCountWithParams++;
				});
			}
			// a niceUrl-es kereséseket a komponensek (property-search-bar + advanced-search) inditjak, a sima innen megy
			if (!window.location.hash) {
				this.propertySearch({});
			}
			this.initIsInViewport();
		}

		initIsInViewport() {
			let self = this; // angular ctrl
			$.fn.isInViewport = function () {
				let elementTop = $(this).offset().top;
				let elementBottom = elementTop + $(this).outerHeight();

				let viewportTop = $(window).scrollTop();
				let viewportBottom = viewportTop + $(window).height();

				return elementBottom > viewportTop && elementTop < viewportBottom;
			};

			$('.ip-content-container').on('resize scroll', function (e) {
				$('.m16-list-and-map-view__switcher--not-fixed').each(function () {
					if ($(this).isInViewport()) {
						self.isOtherSwitcherVisible = true;
					} else {
						if ($(this).position().top > window.pageYOffset) {
							self.isOtherSwitcherVisible = false;
						}
					}
				});
			});
		}

		searchFromSavedData() {
			this.niceUrl = this.niceUrlService.createNiceUrl(Object.assign({}, this.advancedSearchFormData || {}, this.formData));
			window.location.hash = this.niceUrl;
			this.propertySearch(this.formData);
		}

		saveSearchData(formData) {
			this.formData = formData;
			if (!(this.firstLoad.searchBar && this.firstLoad.advanced)) {
				window.location.hash = this.niceUrlService.createNiceUrl(Object.assign({}, this.advancedSearchFormData || {}, this.formData));
			}
		}

		propertySearch(formData) {
			if ((!formData || angular.equals(formData, {})) && window.searchParams) {
				if (window.searchParams.hely) {
					window.searchParams.selectedTags = window.searchParams.hely.split('|');
					delete window.searchParams.hely;
				}
				if (window.searchParams.selectedTags) {
					window.searchParams.locationTypes = new Array(window.searchParams.selectedTags.length).fill(window.searchParams.mapType);
				}
				if (window.searchParams.ingatlantipusa) {
					window.searchParams.ingatlantipusa = parseInt(window.searchParams.ingatlantipusa, 10);
				}
				formData = window.searchParams;
			}
			this.saveSearchData(formData);
			this.firstLoad.searchBar = false;
			this.showResultList = false;
			let allFormData = {};
			Object.assign(allFormData, this.advancedSearchFormData || {}, formData);
			this.search(allFormData);
		}

		doAdvancedSearch(advancedSearchFormData) {
			this.advancedSearchFormData = advancedSearchFormData;
			// if (!noHashCreation) {
			// 	window.location.hash = this.niceUrlService.createNiceUrl(Object.assign({}, this.advancedSearchFormData, this.formData || {}));
			// }
			this.showResultList = false;
			let allFormData = {};
			Object.assign(allFormData, this.formData || {}, angular.copy(advancedSearchFormData));
			this.resetParams(allFormData);
			this.search(allFormData, true);
		}

		/** lapozó, koordináták resetelése RÉSZLETES KERESŐ-re kattintva */
		resetParams(allFormData) {
			delete allFormData.page;
			delete allFormData.pageSize;
			delete allFormData.location;
			if (allFormData.keyword && (allFormData.keyword == '' || allFormData.keyword[0] == '')) {
				delete allFormData.keyword;
			}
		}

		search(allFormData, advanced) {
			if (allFormData.mNumber) {
				window.location.href = '/ingatlan/' + allFormData.mNumber;
			}
			this.$scope.$broadcast('closePopups');
			this.allFormData = allFormData;
			this.loaderService.show();
			this.propertySearchResultItems = null;
			this.SearchService.getRealEstateSearchResults(this.allFormData).then((response) => {
				this.propertySearchResultItems = response.data.hits.content;
				this.propertySearchResultItems.forEach(e => {
					e.images = this.$filter('picOrderFilter')(e.images);
				});
				/*
				// Lazy
				this.propertySearchResultItems[0].images.push({
					url: '/static/assets/sitebuild/img/career-01.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/career-02.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/career-03.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				});

				this.propertySearchResultItems[1].images.push({
					url: 'https://www.realestate.com.au/blog/images/1885x1414-fit,progressive/2018/02/26012408/investing-property-with-superannuation_2000x1500.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-02.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-03.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-04.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: '/static/assets/sitebuild/img/ingatlan-05.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				});

				this.propertySearchResultItems[2].images.push({
					url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://www.hindustantimes.com/rf/image_size_640x362/HT/p2/2016/11/15/Pictures/dream-house-front_8843d09c-ab15-11e6-b961-04ee4fa7b706.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://cms.homeaway.com/files/live/sites/hub/files/contributed/homepage/marketing/list-your-property.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://www.propertylife.my/wp-content/uploads/2016/12/Sunway-property-3.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				}, {
					url: 'https://d27p8o2qkwv41j.cloudfront.net/wp-content/uploads/2017/08/shutterstock_516637903-e1504758036917.jpg',
					websetaUrl: '',
					isLayout: false,
					isPreview: false
				});

				*/
				this.responseData = response.data.hits;
				this.loanInfo = Object.keys(response.data.loanInfo).length ? response.data.loanInfo : null;

				// mock hitellel elérhető ingatlanhoz
				// this.loanInfo = {maxPriceByUser: 4000000, loanAmount: 1600000, thm: 6.2, duration: 15, monthlyPayment: 13074};

				this.showResultList = true;
				if (this.isLoggedIn) {
					this.checkSearchIsExist();
					this.checkSearchesCount();
				}
				this.showAdvancedSearch = false;
				if (advanced) {
					window.dataLayer.push({
						event: 'propertySearchResultwithFilter',
						searchNo: this.propertySearchResultItems.length
					});
				}
				this.loaderService.hide();
				angular.element('body').removeClass('overflow-hidden');
				angular.element('html, body').animate({ scrollTop: 0 }, 500);
			}, () => {
				this.loaderService.hide();
				this.notificationService.showError({ message: 'technicalError' });
				this.propertySearchResultItems = [];
				this.responseData = {};
				this.loanInfo = null;
				angular.element('body').removeClass('overflow-hidden');
			});
		}

		saveAdvancedSearchData(data) {
			this.advancedSearchFormData = data;
			if (!(this.firstLoad.searchBar && this.firstLoad.advanced)) {
				delete this.formData.page;
				delete this.formData.pageSize;
				let hash = this.niceUrlService.createNiceUrl(Object.assign({}, this.advancedSearchFormData, this.formData || {}));
				if (hash != '#/') {
					window.location.hash = hash;
				} else {
					window.location.hash = '';
				}
			}
			this.firstLoad.advanced = false;

		}

		openNewSearchDialog() {
			this.$rootScope.$broadcast('resetSearch');
			this.showFilters();
		}

		showFilters() {
			this.$mdDialog.show({
				template: advancedSearchMobile(),
				clickOutsideToClose: true,
				controller: () => this,
				controllerAs: '$ctrl'
			});
		}

		closeDialog() {
			this.$mdDialog.hide();
			angular.element('body').removeClass('overflow-hidden');
		}

		fixSearchBarToTop() {
			$(document).ready(function () {

				let searchBar = $('#searchBar');

				// hiába az onready event, valamiért 0 a top
				window.addEventListener('scroll', function (e) {
					// krómban csak ennek az inline ccs-nek a vizsgálatával marad ott mindig
					let changed = false;
					let mapContainerClass = '.m16-list-and-map-view__map';
					let propertyListClass = '.m17-property-list';
					let stickyClass = 'm16-list-and-map-view__map--sticky';
					let stickyPropertyListClass = 'm17-property-list--sticky';
					if ($(this).scrollTop() > 120) {
						that.stickyTop = 110;
						searchBar.addClass('section--fixed');
						changed = !$(mapContainerClass).hasClass(stickyClass);
						$(mapContainerClass).addClass(stickyClass);
						$(propertyListClass).addClass(stickyPropertyListClass);
					} else {
						that.$scope.$apply(() => {
							that.stickyTop = 223 - $(this).scrollTop() + 'px';
						})
						if (!($('body').hasClass('md-dialog-is-showing') || $('body').offset().top < 0)) {
							searchBar.removeClass('section--fixed');
						}
						changed = $(mapContainerClass).hasClass(stickyClass);
						$(mapContainerClass).removeClass(stickyClass);
						$(propertyListClass).removeClass(stickyPropertyListClass);
					}
					if (changed) {
						that.$scope.$broadcast('mapResize', {});
					}
				});
			});
		}

		changeView($event) {
			this.showList = $event.showList;
			this.showMap = $event.showMap;
			if ($event.showMap) {
				this.$timeout(() => {
					// ugly way to trigger map reload, resize
					this.propertySearchResultItems = angular.copy(this.propertySearchResultItems);
				});
			} else {
				// todo loader
				this.$timeout(() => {
					// todo loader off
					$(window).trigger('resize');
				}, 500);
			}
		}

		viewChange(showList, showMap) {
			let param = {
				$event: {
					showList: showList,
					showMap: showMap
				}
			};
			this.changeView(param.$event);
		}

		searchPagerOrOrder(event) {
			this.formData.order = event.order ? event.order : this.formData.order;
			this.formData.page = event.paging.page;
			this.formData.pageSize = event.paging.pageSize;
			this.saveSearchData(this.formData);
			this.searchFromSavedData();
		}

		checkSearchIsExist() {
			let param = {
				url: window.location.href
			};
			this.searchesService.checkExistance(param).then((response) => {
				this.existedSearch = response.data || { name: 'létezik' };
			}).catch(() => {
				// nem létezik a keresés
				this.existedSearch = {};
			});
		}

		checkSearchesCount() {
			this.searchesService.getSavedSearches().then((response) => {
				this.savedSearchCount = response.data.totalElements;
			}).catch((error) => {
				console.log(error);
			});
		}

		toggleShowAdvancedSearch() {
			this.showAdvancedSearch = !this.showAdvancedSearch;
			if (this.showAdvancedSearch) {
				angular.element('body').addClass('overflow-hidden');
			} else {
				angular.element('body').removeClass('overflow-hidden');
			}
		}
	}
};
